import { cva } from "class-variance-authority";

export const TitleColor = cva("", {
  variants: {
    theme: {
      light: "text-black",
      dark: "text-white"
    }
  }
});
